export enum EMagicLinkFlow {
  SIGN_IN = "signin",
  SIGN_UP = "signup",
}
